<molecule-info-card-search
    [mode]="INFO_CARD_SEARCH_MODE.Link"
    [infoCards]="
        formTemplates | fn : formTemplatesAsInfoCardData : entityId : entityType
    "
    [isLoading]="formTemplatesIsLoading"
    [hasError]="formTemplatesHasError"
    [clientSideSearch]="true"
></molecule-info-card-search>
